export default "__VITE_ASSET__f0c6fcfd__"